<template>
    <div class="sps-card sps-card--announcement" :class="{ 'is-pinned': card.pinned }"><div class="sps-card__title">{{ lc.title }}</div><p class="sps-card__body">{{ lc.body }}</p></div>
</template>
<script>
import { mapState } from "vuex";
import { pickLanguageContent } from "../../../../utils/shell/pickLanguageContent";
export default { name: "AnnouncementCard", props: { card: { type: Object, required: true } }, computed: { ...mapState({ defaultLocale: (s) => s.catalog.defaultLocale }), lc() { return pickLanguageContent(this.card.languageContent, this.$i18n.locale, this.defaultLocale) || {}; } } };
</script>
<style lang="scss">
// sabit duyuru: kaydirmada ustte kalir, altindaki kartlardan ayrissin diye vurgulu
.sps-card--announcement.is-pinned { background: var(--sps-surface, #fff); box-shadow: 0 6px 22px rgba(30, 30, 80, 0.18);
    .sps-card__title { display: flex; align-items: center; gap: 6px; }
    .sps-card__title::before { content: ""; width: 8px; height: 8px; border-radius: 50%; background: var(--button-color, #4f46e5); flex: none; }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/shell/cards/AnnouncementCard.vue